// Chiamate al server dell'area clienti (token del CLIENTE, mai quello del personale: fetch e non axios).
import { tr, trServer, lingua } from './areaClientiLingua';

export const BASE = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BASE}/api/area-clienti`;

async function leggi(r) {
  if (r.status === 413) {
    const err = new Error(tr('Foto troppo pesanti: togline qualcuna e riprova'));
    err.status = 413;
    throw err;
  }
  const dati = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(typeof dati.detail === 'string' ? trServer(dati.detail) : tr('Si è verificato un errore, riprova'));
    err.status = r.status;
    throw err;
  }
  return dati;
}

// dentro l'app Android/iPhone: il server lo sa (interruttore "pubblicazione annunci dall'app")
const daApp = () => (typeof window !== 'undefined' && window.ReactNativeWebView ? { 'X-App': '1' } : {});

export async function chiama(percorso, { metodo = 'GET', corpo, token } = {}) {
  const r = await fetch(`${API}${percorso}`, {
    method: metodo,
    headers: { 'Content-Type': 'application/json', 'X-Lingua': lingua(), ...daApp(), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: corpo ? JSON.stringify(corpo) : undefined,
  });
  return leggi(r);
}

// modulo con file (annunci con foto): campo "dati" = JSON, campi "foto" = file
export async function chiamaModulo(percorso, { metodo = 'POST', dati, file = [], token }) {
  const fd = new FormData();
  fd.append('dati', JSON.stringify(dati));
  file.forEach((f) => fd.append('foto', f, f.name || 'foto.jpg'));
  const r = await fetch(`${API}${percorso}`, {
    method: metodo, body: fd,
    headers: { 'X-Lingua': lingua(), ...daApp(), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  return leggi(r);
}

// immagine che richiede il token (foto dei propri annunci non ancora online) → URL locale
export async function immagineConToken(url, token) {
  const r = await fetch(`${BASE}${url}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) throw new Error('foto');
  return URL.createObjectURL(await r.blob());
}
